import React, { useState } from 'react';

const AlbumFilters = ({ activities, onFilterChange }) => {
  const [selectedActivity, setSelectedActivity] = useState('');

  return (
    <div className="ml-64 p-6">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex flex-wrap gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fecha</label>
            <input
              type="date"
              onChange={(e) => onFilterChange({ date: e.target.value })}
              className="px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Actividad</label>
            <select
              value={selectedActivity}
              onChange={(e) => {
                setSelectedActivity(e.target.value);
                onFilterChange({ activity: e.target.value });
              }}
              className="px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Todas</option>
              {activities.map(act => (
                <option key={act} value={act}>{act}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumFilters;

// DONE